import React from "react";
import Link from "next/link";

const Logo = () => {
  return (
    <Link href="/">
      <a style={{textDecoration:"none", color:"white"}}>
      <div className="logo">
        <span className="logo-title">
          <span className="logo-text">Tax ID/EIN Application {`(${new Date().getFullYear()})`}</span>
          <span className="logo-subtext">Approved 3rd Party eFile Provider</span>
        </span>
      </div>
      </a>
    </Link>
  );
};

export default Logo;
